import React, { Component } from "react";
import { Col, Card, Form, Button, Icon } from "antd";
import _ from "lodash";

import { formatRupiah } from "../../../../Utils";

class MobbiInformation extends Component {
  render() {
    let recomendationPrice = _.get(
      this.props.tradeIn,
      "Appraisal.Booking.MobbiPayload.recommendationPrice"
    );

    let mobbiId = _.get(
      this.props.tradeIn,
      "Appraisal.Booking.MobbiPayload.mobbiId"
    );
    return this.props.isTrust ? (
      <div></div>
    ) : (
      <Col xs={24} md={24}>
        <Card
          title="Mobbi Information"
          headStyle={{ backgroundColor: "#034F8A", color: "white" }}
          bodyStyle={{ backgroundColor: "#FFBA3A" }}
          color="white">
          <Col xs={24} md={12}>
            <Form.Item label="Rekomendasi Harga dari Mobbi">
              <span
                className="ant-form-text form-text-mod"
                style={{ lineHeight: "30px" }}>
                {formatRupiah(recomendationPrice) || "Rp.0"}
              </span>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item label="Mobbi Id">
              <span
                className="ant-form-text form-text-mod"
                style={{ lineHeight: "30px" }}>
                {mobbiId || "-"}
              </span>
            </Form.Item>
          </Col>
        </Card>
      </Col>
    );
  }
}

export default MobbiInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/MobbiInformation.js